module.exports = __webpack_public_path__ + "static/media/mobile-app.88b21795.png";